import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import ChartItemAdmissions from 'src/components/kinotoppen/ChartItemAdmissions';
import ChartItemPremiere from 'src/components/kinotoppen/ChartItemPremiere';
import theme from 'src/components/themes/DefaultTheme';
import { MovieChartItem as MovieChartItemType } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

//#region [Props]
type MovieChartItemProps = {
	chartItem: MovieChartItemType;
};
//#endregion

//#region [Component]
export default function MovieChartItem({ chartItem }: MovieChartItemProps) {
	return <SMovieChartItem to={`/film/${chartItem.movie!.mainVersionId}`}>
		<SChartPosition>
			{chartItem.pos}
			<SPreviousChartPosition>{chartItem.posPrev}</SPreviousChartPosition>
		</SChartPosition>
		<SPoster>
			{chartItem.movie!.sanityImagePosterUrl && <SChartPoster
				imageUrl={chartItem.movie!.sanityImagePosterUrl}
				alt={`Plakat for ${chartItem.movie!.title}`}
				width={100}
				unoptimized
				isPosterAspect />}
		</SPoster>
		<SDetails>
			<SMovieTitle>{chartItem.movie!.title}</SMovieTitle>
			<ChartItemPremiere premiere={chartItem.movie?.premiere} />
			<ChartItemAdmissions label="Uker" value={chartItem.weeksOnList} />
			<ChartItemAdmissions label="Besøk" value={chartItem.admissions} />
			<ChartItemAdmissions label="Besøk forrige" value={chartItem.admissionsPrev} />
			<ChartItemAdmissions label="Totalt" value={chartItem.admissionsToDate} />
		</SDetails>
	</SMovieChartItem>;
}
//#endregion

//#region [Styles]
const SMovieChartItem = styled(FilmwebLink)`
	text-decoration: none;
	color: var(--textcolor);

	display: flex;
	min-height: 150px;
	border-radius: 8px;
	position: relative;

	background-color: var(--buttoncolor);
	margin: 0 ${theme.maxContentPadding};

	@media ${theme.mq.desktop} {
		margin: 0;
	}

`;

const SChartPosition = styled.div`

	flex-basis: 100px;
	min-width: 100px;
	align-self: center;
	text-align: center;
	font-size: 3rem;
	font-weight: bold;

	@media ${theme.mq.desktop} {
		//@media  (orientation: landscape) {
		flex-basis: 150px;
	}
`;

const SPreviousChartPosition = styled.div`
	position: absolute;
	left: 10px;
	bottom: 10px;
	font-size: 1rem;
`;

const SPoster = styled.div`
	display: none;
	align-self: center;

	@media ${theme.mq.desktop} {
		display: block;
	}
`;

const SChartPoster = styled(CmsImageForUrl)`
	max-width: 100%;
	height: 130px;
	width: auto;
	transform: none;
`;

const SDetails = styled.div`
	padding: 10px 10px 10px 0;
	@media ${theme.mq.desktop} {
		padding: 20px;
	}
`;

const SMovieTitle = styled.div`
	font-size: 1.5rem;
	line-height: 105%;

	@media ${theme.mq.desktop} {
		//@media  (orientation: landscape) {
		font-size: 2rem;
		margin-bottom: 30px;
	}
`;
//#endregion